import { useState, createContext, useEffect } from "react"
const CurrencyContext = createContext();
const CommonContext = createContext();

function ContextProvider(props) {
	const [currency, setCurrency] = useState("$")
	const [common, setCommon] = useState(() => {
			const saved = sessionStorage.getItem("common");
	
			return saved
				? JSON.parse(saved)
				: {
					buyerId:null,
					boostCredits:0
				};
		});
	
		useEffect(() => {
			sessionStorage.setItem("common", JSON.stringify(common));
		}, [common]);

	function changeCurrencyValue(value) {
		setCurrency(value)
	}
	function changeCommonValues(newValues) {
		setCommon(prev => ({
			...prev,
			...newValues,
		}));
	}
	
	return (
		<CommonContext.Provider value={{common,changeCommonValues}}>
		<CurrencyContext.Provider value={{currency,changeCurrencyValue}}>
			{props.children}
		</CurrencyContext.Provider>
		</CommonContext.Provider>
		)
}
export {ContextProvider,CurrencyContext,CommonContext}
